import { Breakpoint, useMediaQuery } from '@/hooks/useMediaQuery';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

interface BreakpointContextValue {
  isBigDesktop: boolean;
  isDesktop: boolean;
  isTablet: boolean;
  isPhone: boolean;
  isMobile: boolean;
}

const BreakpointContext = createContext<BreakpointContextValue | undefined>(
  undefined,
);

export function BreakpointProvider({ children }: { children: ReactNode }) {
  const isBigDesktop = useMediaQuery(Breakpoint.XL);
  const isDesktop = useMediaQuery(Breakpoint.LG);
  const isTablet = useMediaQuery(Breakpoint.MD);
  const isPhone = useMediaQuery(Breakpoint.SM);

  const isMobile = !isDesktop;

  return (
    <BreakpointContext.Provider
      value={{ isBigDesktop, isDesktop, isTablet, isPhone, isMobile }}
    >
      {children}
    </BreakpointContext.Provider>
  );
}

export function useBreakpoint() {
  const context = useContext(BreakpointContext);
  if (context === undefined) {
    throw new Error('useBreakpoint must be used within a BreakpointProvider');
  }
  return context;
}
